import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { FormikProps } from "formik";
import { MyTimesheetNewProjectDialog } from "my-timesheet/components";
import { useMyTimesheetProjectList } from "my-timesheet/hooks";
import { OcFormEditorItemList } from "oc/components";
import { useOcFormEditorSelector } from "oc/hooks";

interface MyTimesheetProjectSelectorProps {
  formik: FormikProps<any>;
}

export const MyTimesheetProjectSelector = ({
  formik,
}: MyTimesheetProjectSelectorProps) => {
  const { t } = useTranslation();
  const [openAddProjectDialog, setOpenAddProjectDialog] = useState(false);

  const { data: projectsData, createMySheetProject } =
    useMyTimesheetProjectList({
      page: 1,
      pageSize: 100,
      sort: "name",
      sortDirection: "asc",
      searchText: "",
      searchField: "",
    });

  const {
    list: projectList,
    search: projectSearch,
    selectedItem: selectedProject,
    handleSearch: handleProjectSearch,
    handleClearSearch: handleProjectClearSearch,
    handleHasMore: handleProjectHasMore,
  } = useOcFormEditorSelector({
    value: formik.values.projectId,
    list: projectsData?.rows || [],
  });

  const handleChange = (value: string | number) => {
    formik.setFieldValue("projectId", value);
  };

  const handleAddNewProject = () => {
    setOpenAddProjectDialog(true);
  };

  const closeAddProjectDialog = () => {
    setOpenAddProjectDialog(false);
    //formik.resetForm();
  };

  return (
    <>
      <MyTimesheetNewProjectDialog
        openAddProjectDialog={openAddProjectDialog}
        closeAddProjectDialog={closeAddProjectDialog}
        createMySheetProject={createMySheetProject}
      />
      <OcFormEditorItemList
        key={"project"}
        value={selectedProject}
        list={projectList}
        label={t("MY_TIMESHEET_PROJECT")}
        search={projectSearch}
        onSearch={handleProjectSearch}
        onChange={(type, value) => {
          handleChange(value);
        }}
        onClearSearch={handleProjectClearSearch}
        onScroll={handleProjectHasMore}
        name={"project"}
        error={false}
        module="MyTimesheet"
        addNewProject={handleAddNewProject}
      />
    </>
  );
};

export default MyTimesheetProjectSelector;
